/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Promotion Restriction
 * @export
 * @interface PromotionRestriction
 */
export interface PromotionRestriction {
    /**
     * Type of the promotion restriction
     * @type {string}
     * @memberof PromotionRestriction
     */
    restrictionType?: string;
    /**
     * Description of the promotion restriction
     * @type {string}
     * @memberof PromotionRestriction
     */
    description?: string;
}

/**
 * Check if a given object implements the PromotionRestriction interface.
 */
export function instanceOfPromotionRestriction(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PromotionRestrictionFromJSON(json: any): PromotionRestriction {
    return PromotionRestrictionFromJSONTyped(json, false);
}

export function PromotionRestrictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionRestriction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'restrictionType': !exists(json, 'restrictionType') ? undefined : json['restrictionType'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function PromotionRestrictionToJSON(value?: PromotionRestriction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'restrictionType': value.restrictionType,
        'description': value.description,
    };
}

